import { jsxs as C, jsx as p } from "react/jsx-runtime";
import { useState as v, useEffect as z, createElement as B } from "react";
import "@fcamna/shared-component-foundations";
import { u as M } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as O } from "./useSlots-a1aa6a84.mjs";
import { Chip as I, ChipGroup as b } from "./chip.js";
import { D as l } from "./index-2be68378.mjs";
import a, { css as h } from "styled-components";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./badge.js";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./useWindowSize-88e90e04.mjs";
import "./modalWindow.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useClient-0bbce34e.mjs";
import "./Aria-f5e019e2.mjs";
import "./disclosure.js";
import "./focusTrap.js";
import "./hTag-27bb1617.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./divider.js";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./helperText-d9646f54.mjs";
import "./menu.js";
import "./textInput.js";
import "./radio.js";
const $ = ({
  children: t,
  menuLists: e = [],
  menuHeader: r,
  value: m = [],
  onChange: F,
  leadingIcon: P,
  isRadio: u = !1,
  isDisabled: g,
  menuDirection: T,
  exceedOverflow: j = !1,
  onBlur: k
}) => {
  const q = M({ label: "Filter" }), [S, A] = v(!1), [c, y] = v(m);
  z(() => {
    y(m);
  }, [JSON.stringify(m)]);
  const D = (o, i) => {
    const s = u ? [i == null ? void 0 : i.value] : i.map((n) => n == null ? void 0 : n.value);
    y(s), F && F(o, {
      label: t,
      values: s,
      isActive: !!s.length
    });
  }, E = (o) => o == null ? void 0 : o.map(({ title: i, items: s }, n) => [
    i && /* @__PURE__ */ p(l.Title, { children: i }, `title-${n}`),
    s.map(({ label: G, value: d = G, description: w = "", trailingElement: x = "" }) => /* @__PURE__ */ p(
      l.Item,
      {
        label: G,
        value: d,
        description: w,
        trailingElement: x,
        isSelected: c.includes(d)
      },
      d
    )),
    n !== o.length - 1 && /* @__PURE__ */ p(l.Divider, {}, `divider-${n}`)
  ]);
  return /* @__PURE__ */ C(
    l,
    {
      menuOpen: S,
      handleMenuOpen: (o) => A(o),
      menuHeader: r,
      onChange: D,
      menuDirection: T,
      type: u ? "radio" : "multiple",
      isDisabled: g,
      exceedOverflow: j,
      ...q,
      children: [
        /* @__PURE__ */ p(l.Control, { children: /* @__PURE__ */ p(
          I,
          {
            badgeProps: {
              value: `${c.length > 0 ? c.length : ""}`,
              size: "small",
              type: "primary",
              emphasis: "high"
            },
            leadingIcon: P,
            isRadio: u,
            isActive: c.length > 0,
            isDisabled: g,
            onClick: k,
            isOpen: S,
            variant: "filter",
            children: t
          }
        ) }),
        E(e)
      ]
    }
  );
}, J = a.div`
  ${({
  theme: {
    components: { filter: t }
  }
}) => h(t.FilterContainer)};
`, N = a.div`
  ${({
  theme: {
    components: { filter: t }
  }
}) => h(t.ChipGroupContainer)};
`, Q = a.div`
  ${({
  theme: {
    components: { filter: t }
  }
}) => h(t.FilterGroup)};
`, Dt = a.div`
  ${({
  theme: {
    components: { filter: t }
  }
}) => h(t.TableFilterContainer)};
`, H = ({ ...t }) => {
  const e = O(t.children, { Filters: $ });
  return /* @__PURE__ */ C(Q, { ...t, children: [
    e.Filters.map((r, m) => /* @__PURE__ */ B(
      $,
      {
        ...r == null ? void 0 : r.props,
        onChange: (r == null ? void 0 : r.props.onChange) || (() => ""),
        key: "filter" + m
      },
      String(r == null ? void 0 : r.props.children) || ""
    )),
    e.rest
  ] });
}, f = ({ ...t }) => {
  const e = M({ label: "Filter Group" }), r = O(t.children, { Container: f.Container, ChipGroup: b });
  return /* @__PURE__ */ C(
    J,
    {
      ...t,
      ...e,
      children: [
        r.Container,
        /* @__PURE__ */ p(N, { children: r.ChipGroup })
      ]
    }
  );
};
f.Container = H;
f.ChipGroup = b;
export {
  $ as Filter,
  f as FilterGroup,
  H as FiltersContainer,
  N as StyledChipGroupContainer,
  J as StyledFilterContainer,
  Q as StyledFilterGroup,
  Dt as StyledTableFilterGroup
};
